import React from "react";
export function Calavera({
  className = ""
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 56" aria-hidden="true" className={className} data-id="element-61" data-mp="3jygv26b22fmv">
      <path d="M24 2C11 2 3 11 3 23c0 8 4 13 8 16v8c0 3 2 5 5 5h16c3 0 5-2 5-5v-8c4-3 8-8 8-16C45 11 37 2 24 2Z" fill="#FBF3E4" stroke="#0F3B2E" strokeWidth="2" data-id="element-62" data-mp="3k0a05h60srsr" />
      {[15, 33].map(x => <g key={x} data-id="element-63" data-mp="367bp6mh3gr43">
          <circle cx={x} cy="24" r="6" fill="#1F4E9C" data-id="element-64" data-mp="367ttm6dwubn3" />
          {[0, 72, 144, 216, 288].map(angle => <ellipse key={angle} cx={x} cy="20.5" rx="1.3" ry="2.2" fill="#E8871E" transform={`rotate(${angle} ${x} 24)`} data-id="element-65" data-mp="316wek2o75xpt" />)}
          <circle cx={x} cy="24" r="1.3" fill="#F2C230" data-id="element-66" data-mp="2wap888rw2k7c" />
        </g>)}
      <path d="M24 31l-3 5h6z" fill="#C1272D" data-id="element-67" data-mp="2rb2tfuwewvwf" />
      <path d="M15 44h18" stroke="#0F3B2E" strokeWidth="1.6" data-id="element-68" data-mp="ugzm58rzm5za" />
      {[18, 22, 26, 30].map(x => <path key={x} d={`M${x} 41v6`} stroke="#0F3B2E" strokeWidth="1.2" data-id="element-69" data-mp="pieo9g07jye0" />)}
      <circle cx="24" cy="10" r="3" fill="#D6336C" data-id="element-70" data-mp="prjib5snhx02" />
      <circle cx="18" cy="11" r="1.2" fill="#1CA7A8" data-id="element-71" data-mp="pqqfgfwtbrn7" />
      <circle cx="30" cy="11" r="1.2" fill="#1CA7A8" data-id="element-72" data-mp="uqcxd2nl5w2c" />
    </svg>;
}